import React from "react";
import {
  Radar,
  RadarChart as RC,
  PolarGrid,
  PolarAngleAxis,
  PolarRadiusAxis,
  ResponsiveContainer,
  Tooltip,
} from "recharts";

/**
 * Radar chart for 12 motives.
 * scores: {motive_slug: 0-100}
 * motives: [{slug, short, name}...] in order
 */
export default function MotiveRadar({ scores, motives, height = 380 }) {
  const data = motives.map((m) => ({
    motive: m.short,
    fullName: m.name,
    value: scores[m.slug] || 0,
  }));

  return (
    <div style={{ width: "100%", height }} data-testid="motive-radar-chart">
      <ResponsiveContainer>
        <RC data={data} outerRadius="75%">
          <PolarGrid stroke="rgba(255,255,255,0.1)" />
          <PolarAngleAxis
            dataKey="motive"
            tick={{
              fill: "#ffffff",
              fontSize: 11,
              fontFamily: "Barlow, sans-serif",
              fontWeight: 700,
              textTransform: "uppercase",
            }}
          />
          <PolarRadiusAxis
            angle={90}
            domain={[0, 100]}
            tick={{ fill: "#64748B", fontSize: 9 }}
            stroke="rgba(255,255,255,0.1)"
          />
          <Radar
            name="Motive"
            dataKey="value"
            stroke="#CCFF00"
            fill="#CCFF00"
            fillOpacity={0.28}
            strokeWidth={2}
            dot={{ fill: "#CCFF00", r: 3 }}
          />
          <Tooltip
            contentStyle={{
              background: "#111214",
              border: "1px solid rgba(255,255,255,0.15)",
              borderRadius: 6,
              fontFamily: "DM Sans, sans-serif",
            }}
            labelStyle={{ color: "#CCFF00", fontWeight: 700 }}
            formatter={(v, _n, entry) => [`${v}%`, entry.payload.fullName]}
          />
        </RC>
      </ResponsiveContainer>
    </div>
  );
}
